import type { ABTest } from './helpers';
import {
  FORCED_TESTS_COOKIE_NAME,
  REGULAR_TESTS_COOKIE_NAME,
  getTests,
  extractTestName,
} from './helpers';

/**
 * Возвращает массив тестовых групп пользователя на основе кук abst и abst-forced.
 * Значения тестовых групп из куки abst-forced имеют приоритет над abst.
 * @see Подробнее в {@link https://bitbucket.org/OneTwoTrip/front-components/src/master/src/components/misc/ABTest/README.md README}
 */
export const getAvailableTests = (): ABTest[] => {
  const forcedTests = getTests(FORCED_TESTS_COOKIE_NAME);
  const regularTests = getTests(REGULAR_TESTS_COOKIE_NAME);

  if (forcedTests.length === 0) {
    return regularTests;
  }

  const forcedTestsNames = forcedTests.map(extractTestName);
  const filteredRegularTests = regularTests.filter(
    (test) => !forcedTestsNames.some((forcedTestName) => test.startsWith(forcedTestName))
  );

  return [...forcedTests, ...filteredRegularTests];
};
